import React, { useMemo } from "react";
import clsx from "clsx";
const estilosLegenda = require('./legenda.module.scss').default;

export type LegendaProps = {
    itens: {
        cor?: string;
        nome?: string;
        title?: string
    }[];
};

const Legenda = React.memo((props: LegendaProps) => {
    // Generate stable keys based on item content and prevent unnecessary re-renders
    const itensMemoizados = useMemo(() => {
        return props.itens.map((item, index) => {
            const uniqueKey = `${item.nome}_${index}`.replace(/\s+/g, '_')
            return (
                <div 
                    key={`legenda_div_${uniqueKey}`} 
                    id={`legenda_div_${uniqueKey}`}
                    className={estilosLegenda.legenda}
                    aria-label={`Legenda para ${item.nome}`}
                >
                    <div 
                        key={`legenda_Div2_${uniqueKey}`} 
                        id={`legenda_div2_${uniqueKey}`}
                        className={estilosLegenda.cor} 
                        title={item.title ? item.title : undefined}
                        style={{ backgroundColor: item.cor }}
                        aria-hidden="true"
                    />
                    <span className={estilosLegenda.texto}
                        key={`legenda_span_${uniqueKey}`} 
                        id={`legenda_span_${uniqueKey}`}
                        title={item.title ? item.title : undefined}
                    >{item.nome}</span>
                </div>
            );
        });
    }, [props.itens]);

    return (
        <div className={estilosLegenda.container1} role="region" aria-label="Legenda"
            key={`legenda`} 
            id={`legenda`}     
        >
            <div className="_text-lg _font-bold _text-blue-500"
                key={`legenda_texto_Legenda`} 
                id={`legenda_texto_Legenda`}   
                style={{cursor: 'default'}} 
            >Legenda</div>
            <div 
                key={`legenda_div_itens`} 
                id={`legenda_div_itens`}  
                className={clsx(estilosLegenda.container2, "_mt-4")}
                role="list"
            >
                {itensMemoizados}
            </div>
        </div>
    );
});

export default Legenda;